(function () {
  if (customElements.get('ingredient-catch-game')) return;

  var STORE_KEY = 'naturall-ingredient-catch-best';
  var INK = '#173F2D';
  var BG = '#ECD5DB';
  var SIZE = 400;
  var IVY_Y = 338;
  var IVY_R = 26;
  var KINDS = [
    { type: 'avocado', points: 1, weight: 0.36 },
    { type: 'kiwi', points: 1, weight: 0.3 },
    { type: 'shea', points: 2, weight: 0.12 },
    { type: 'bubble', points: -3, weight: 0.22 }
  ];

  function storeKey(player) { return player ? STORE_KEY + ':' + player : STORE_KEY; }
  function readBest(player) {
    try { return parseInt(window.localStorage.getItem(storeKey(player)), 10) || 0; } catch (e) { return 0; }
  }
  function saveBest(value, player) {
    try { window.localStorage.setItem(storeKey(player), String(value)); } catch (e) {}
    document.querySelectorAll('ingredient-catch-game[data-player="' + (player || '') + '"] [data-best]').forEach(function (el) { el.textContent = value; });
  }

  class IngredientCatchGame extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      if (!this.canvas || this.ctx) return;
      this.ctx = this.canvas.getContext('2d');
      this.player = this.dataset.player || '';
      this.best = readBest(this.player);
      if (this.player && this.best === 0 && readBest('') > 0) {
        this.best = readBest('');
        saveBest(this.best, this.player);
      }
      this.querySelectorAll('[data-best]').forEach(function (el) { el.textContent = this.best; }, this);
      this.font = getComputedStyle(document.body).fontFamily || 'sans-serif';
      this.roundLength = parseInt(this.dataset.seconds, 10) || 30;
      this.state = 'idle';
      this.face = null;
      this.keys = { left: false, right: false };
      this.reset();

      this.onFrame = this.onFrame.bind(this);
      this.resize = this.resize.bind(this);
      this.resize();
      window.addEventListener('resize', this.resize);

      var self = this;
      this.canvas.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        self.dragging = true;
        if (self.canvas.setPointerCapture) self.canvas.setPointerCapture(event.pointerId);
        if (self.state !== 'running') { self.start(); }
        self.aim(event);
      });
      this.canvas.addEventListener('pointermove', function (event) {
        if (self.state === 'running' && (self.dragging || event.pointerType === 'mouse')) self.aim(event);
      });
      this.canvas.addEventListener('pointerup', function () { self.dragging = false; });
      this.canvas.addEventListener('pointercancel', function () { self.dragging = false; });
      this.canvas.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          self.target = null;
          self.keys[event.key === 'ArrowLeft' ? 'left' : 'right'] = true;
          if (self.state !== 'running') self.start();
        } else if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          if (self.state !== 'running') self.start();
        }
      });
      this.canvas.addEventListener('keyup', function (event) {
        if (event.key === 'ArrowLeft') self.keys.left = false;
        if (event.key === 'ArrowRight') self.keys.right = false;
      });
      var play = this.querySelector('[data-play]');
      if (play) {
        play.addEventListener('click', function () {
          self.canvas.focus({ preventScroll: true });
          if (self.state !== 'running') self.start();
        });
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) self.loadFace();
            else if (self.state === 'running') self.pause();
          });
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      } else {
        this.loadFace();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && self.state === 'running') self.pause();
      });

      this.draw();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resize);
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.raf);
    }

    loadFace() {
      if (this.face || !this.dataset.face) return;
      var img = new Image();
      var self = this;
      img.onload = function () { self.face = img; if (self.state !== 'running') self.draw(); };
      img.src = this.dataset.face;
    }

    resize() {
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      var width = this.canvas.clientWidth || SIZE;
      this.canvas.width = Math.round(width * ratio);
      this.canvas.height = Math.round(width * ratio);
      this.scale = (width * ratio) / SIZE;
      if (this.state !== 'running') this.draw();
    }

    reset() {
      this.x = SIZE / 2;
      this.target = null;
      this.score = 0;
      this.timeLeft = this.roundLength;
      this.items = [];
      this.spawnIn = 0.4;
      this.flash = 0;
      this.pops = [];
      this.newBest = false;
    }

    aim(event) {
      var rect = this.canvas.getBoundingClientRect();
      this.target = ((event.clientX - rect.left) / rect.width) * SIZE;
    }

    start() {
      if (this.state === 'over' || this.state === 'idle') this.reset();
      this.state = 'running';
      this.loadFace();
      this.last = performance.now();
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.onFrame);
    }

    pause() {
      this.state = 'paused';
      cancelAnimationFrame(this.raf);
      this.draw();
    }

    progress() {
      return 1 - this.timeLeft / this.roundLength;
    }

    spawn() {
      var roll = Math.random();
      var kind = KINDS[0];
      var sum = 0;
      var bubbleBoost = this.progress() * 0.12;
      for (var i = 0; i < KINDS.length; i++) {
        sum += KINDS[i].weight + (KINDS[i].type === 'bubble' ? bubbleBoost : 0);
        if (roll * (1 + bubbleBoost) < sum) { kind = KINDS[i]; break; }
      }
      var speed = 140 + this.progress() * 200 + Math.random() * 60;
      this.items.push({
        type: kind.type,
        points: kind.points,
        x: 30 + Math.random() * (SIZE - 60),
        y: -20,
        r: kind.type === 'bubble' ? 16 : 15,
        vy: speed,
        wobble: Math.random() * 6
      });
      this.spawnIn = Math.max(0.28, 0.75 - this.progress() * 0.45) * (0.7 + Math.random() * 0.6);
    }

    onFrame(now) {
      if (this.state !== 'running') return;
      var dt = Math.min((now - this.last) / 1000, 0.034);
      this.last = now;
      this.update(dt);
      this.draw();
      if (this.state === 'running') this.raf = requestAnimationFrame(this.onFrame);
    }

    update(dt) {
      this.timeLeft -= dt;
      if (this.timeLeft <= 0) {
        this.timeLeft = 0;
        this.finish();
        return;
      }

      var maxMove = 520 * dt;
      if (this.keys.left) this.x -= maxMove;
      if (this.keys.right) this.x += maxMove;
      if (this.target !== null) {
        var diff = this.target - this.x;
        this.x += Math.max(-maxMove * 1.4, Math.min(maxMove * 1.4, diff));
      }
      this.x = Math.max(IVY_R, Math.min(SIZE - IVY_R, this.x));

      this.spawnIn -= dt;
      if (this.spawnIn <= 0) this.spawn();
      if (this.flash > 0) this.flash -= dt;

      for (var i = this.items.length - 1; i >= 0; i--) {
        var item = this.items[i];
        item.y += item.vy * dt;
        item.wobble += dt * 3;
        var dx = item.x - this.x;
        var dy = item.y - (IVY_Y - 8);
        if (Math.abs(dx) < IVY_R + item.r - 4 && Math.abs(dy) < IVY_R + item.r - 6) {
          this.score = Math.max(0, this.score + item.points);
          if (item.points < 0) this.flash = 0.25;
          this.pops.push({ x: item.x, y: item.y, text: (item.points > 0 ? '+' : '') + item.points, life: 0.6 });
          this.items.splice(i, 1);
          continue;
        }
        if (item.y > SIZE + 30) this.items.splice(i, 1);
      }
      for (var p = this.pops.length - 1; p >= 0; p--) {
        this.pops[p].life -= dt;
        this.pops[p].y -= 40 * dt;
        if (this.pops[p].life <= 0) this.pops.splice(p, 1);
      }
    }

    finish() {
      this.state = 'over';
      cancelAnimationFrame(this.raf);
      this.keys.left = false;
      this.keys.right = false;
      if (this.score > this.best) {
        this.best = this.score;
        this.newBest = true;
        saveBest(this.best, this.player);
      }
      this.draw();
    }

    draw() {
      var c = this.ctx;
      if (!c) return;
      c.setTransform(this.scale, 0, 0, this.scale, 0, 0);
      c.fillStyle = BG;
      c.fillRect(0, 0, SIZE, SIZE);

      // gentle stripes
      c.fillStyle = 'rgba(255,255,255,0.28)';
      for (var s = 0; s < SIZE; s += 80) c.fillRect(s, 0, 40, SIZE);

      // floor
      c.fillStyle = INK;
      c.fillRect(0, IVY_Y + IVY_R + 8, SIZE, SIZE);

      for (var i = 0; i < this.items.length; i++) this.drawItem(this.items[i]);
      this.drawIvy();

      if (this.flash > 0) {
        c.fillStyle = 'rgba(255,255,255,' + (this.flash * 2) + ')';
        c.fillRect(0, 0, SIZE, SIZE);
      }

      c.textAlign = 'center';
      c.textBaseline = 'middle';
      c.font = '700 18px ' + this.font;
      for (var p = 0; p < this.pops.length; p++) {
        var pop = this.pops[p];
        c.globalAlpha = Math.max(0, pop.life / 0.6);
        c.fillStyle = INK;
        c.fillText(pop.text, pop.x, pop.y);
      }
      c.globalAlpha = 1;

      // header: timer bar and score
      c.fillStyle = 'rgba(23,63,45,0.15)';
      this.roundRect(16, 18, 200, 10, 5);
      c.fill();
      c.fillStyle = INK;
      this.roundRect(16, 18, Math.max(0.001, 200 * (this.timeLeft / this.roundLength)), 10, 5);
      c.fill();
      c.textAlign = 'left';
      c.textBaseline = 'top';
      c.font = '700 14px ' + this.font;
      c.fillText(Math.ceil(this.timeLeft) + 's', 224, 15);
      c.textAlign = 'right';
      c.font = '700 26px ' + this.font;
      c.fillText(String(this.score), SIZE - 16, 10);

      if (this.state !== 'running') {
        c.fillStyle = 'rgba(255,255,255,0.82)';
        this.roundRect(50, 130, 300, 96, 16);
        c.fill();
        c.fillStyle = INK;
        c.textAlign = 'center';
        c.textBaseline = 'middle';
        if (this.state === 'over') {
          c.font = '700 22px ' + this.font;
          c.fillText(this.newBest ? (this.dataset.newBest || '') : String(this.score), SIZE / 2, 162);
          c.font = '400 16px ' + this.font;
          c.fillText(this.dataset.over || '', SIZE / 2, 196);
        } else {
          c.font = '700 20px ' + this.font;
          c.fillText(this.dataset.start || '', SIZE / 2, 178);
        }
      }
    }

    roundRect(x, y, w, h, r) {
      var c = this.ctx;
      r = Math.min(r, w / 2, h / 2);
      c.beginPath();
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }

    drawIvy() {
      var c = this.ctx;
      c.save();
      c.translate(this.x, IVY_Y);
      // curls
      c.fillStyle = INK;
      for (var a = 0; a < 9; a++) {
        var ang = Math.PI + (a / 8) * Math.PI;
        c.beginPath();
        c.arc(Math.cos(ang) * IVY_R * 0.95, Math.sin(ang) * IVY_R * 0.95, 9, 0, Math.PI * 2);
        c.fill();
      }
      c.beginPath();
      c.arc(0, 0, IVY_R, 0, Math.PI * 2);
      c.fillStyle = '#FFFFFF';
      c.fill();
      if (this.face) {
        c.save();
        c.beginPath();
        c.arc(0, 0, IVY_R - 2, 0, Math.PI * 2);
        c.clip();
        c.drawImage(this.face, -IVY_R, -IVY_R, IVY_R * 2, IVY_R * 2);
        c.restore();
      } else {
        c.fillStyle = '#8A5A3C';
        c.beginPath();
        c.arc(0, 2, IVY_R - 4, 0, Math.PI * 2);
        c.fill();
      }
      c.lineWidth = 3;
      c.strokeStyle = INK;
      c.beginPath();
      c.arc(0, 0, IVY_R, 0, Math.PI * 2);
      c.stroke();
      c.restore();
    }

    drawItem(item) {
      var c = this.ctx;
      c.save();
      c.translate(item.x, item.y);
      c.lineWidth = 2.5;
      c.strokeStyle = INK;
      if (item.type === 'avocado') {
        c.rotate(Math.sin(item.wobble) * 0.2);
        c.fillStyle = '#4E7A3A';
        c.beginPath();
        c.ellipse(0, 0, item.r * 0.8, item.r * 1.1, 0, 0, Math.PI * 2);
        c.fill();
        c.stroke();
        c.fillStyle = '#D9E8A6';
        c.beginPath();
        c.ellipse(0, 2, item.r * 0.55, item.r * 0.8, 0, 0, Math.PI * 2);
        c.fill();
        c.fillStyle = '#8A5A3C';
        c.beginPath();
        c.arc(0, 5, item.r * 0.33, 0, Math.PI * 2);
        c.fill();
      } else if (item.type === 'kiwi') {
        c.fillStyle = '#8A6A3C';
        c.beginPath();
        c.arc(0, 0, item.r, 0, Math.PI * 2);
        c.fill();
        c.stroke();
        c.fillStyle = '#8CC63F';
        c.beginPath();
        c.arc(0, 0, item.r * 0.75, 0, Math.PI * 2);
        c.fill();
        c.fillStyle = '#F4F7D9';
        c.beginPath();
        c.arc(0, 0, item.r * 0.25, 0, Math.PI * 2);
        c.fill();
        c.fillStyle = INK;
        for (var k = 0; k < 8; k++) {
          var ka = (k / 8) * Math.PI * 2 + item.wobble * 0.3;
          c.beginPath();
          c.arc(Math.cos(ka) * item.r * 0.45, Math.sin(ka) * item.r * 0.45, 1.4, 0, Math.PI * 2);
          c.fill();
        }
      } else if (item.type === 'shea') {
        c.rotate(Math.sin(item.wobble) * 0.3);
        c.fillStyle = '#F3E6C4';
        c.beginPath();
        c.ellipse(0, 0, item.r * 1.05, item.r * 0.85, 0, 0, Math.PI * 2);
        c.fill();
        c.stroke();
        c.strokeStyle = 'rgba(23,63,45,0.5)';
        c.beginPath();
        c.moveTo(-item.r * 0.5, -2);
        c.quadraticCurveTo(0, -item.r * 0.6, item.r * 0.5, -2);
        c.stroke();
      } else {
        c.fillStyle = 'rgba(255,255,255,0.75)';
        c.beginPath();
        c.arc(0, 0, item.r, 0, Math.PI * 2);
        c.fill();
        c.strokeStyle = '#B04A3A';
        c.stroke();
        c.fillStyle = 'rgba(255,255,255,0.95)';
        c.beginPath();
        c.arc(-item.r * 0.4, -item.r * 0.4, item.r * 0.2, 0, Math.PI * 2);
        c.fill();
        if (this.dataset.bubble) {
          c.fillStyle = '#B04A3A';
          c.font = '700 10px ' + this.font;
          c.textAlign = 'center';
          c.textBaseline = 'middle';
          c.fillText(this.dataset.bubble, 0, 1);
        }
      }
      c.restore();
    }
  }

  customElements.define('ingredient-catch-game', IngredientCatchGame);
})();
